import type { RouteRecordRaw } from 'vue-router';

/**
 * Sales web screens (M8, DECISIONS.md "ADR-077 — Sales & Job Work (M8)" backend, "ADR-078 — Sales &
 * Job Work web screens" this pass). Follows the parallel-work convention established by
 * `procurement.ts`/`finance.ts` — `router.ts` only spreads this array into the app-shell `children`.
 * Job work screens (Textile Dyeing industry pack) live in `routes/textile.ts` (owned by this same
 * work package, WP8.2w — textile.ts is on this agent's file list) so they sit next to the rest of the
 * Textile Dyeing nav, not here.
 */
export const salesRoutes: RouteRecordRaw[] = [
  // ---- Price lists --------------------------------------------------------------------------------
  {
    path: 'sales/price-lists',
    name: 'sales-price-lists',
    component: () => import('../pages/sales/PriceListsPage.vue'),
    meta: { requiresModule: 'sales' },
  },
  {
    path: 'sales/price-lists/new',
    name: 'sales-price-list-new',
    component: () => import('../pages/sales/CreatePriceListPage.vue'),
    meta: { requiresModule: 'sales' },
  },
  {
    path: 'sales/price-lists/:id',
    name: 'sales-price-list-detail',
    component: () => import('../pages/sales/PriceListDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'sales' },
  },
  // ---- Quotations -----------------------------------------------------------------------------------
  {
    path: 'sales/quotations',
    name: 'sales-quotations',
    component: () => import('../pages/sales/QuotationsPage.vue'),
    meta: { requiresModule: 'sales' },
  },
  {
    path: 'sales/quotations/new',
    name: 'sales-quotation-new',
    component: () => import('../pages/sales/CreateQuotationPage.vue'),
    meta: { requiresModule: 'sales' },
  },
  {
    path: 'sales/quotations/:id',
    name: 'sales-quotation-detail',
    component: () => import('../pages/sales/QuotationDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'sales' },
  },
  // ---- Sales orders ---------------------------------------------------------------------------------
  {
    path: 'sales/orders',
    name: 'sales-orders',
    component: () => import('../pages/sales/SalesOrdersPage.vue'),
    meta: { requiresModule: 'sales' },
  },
  {
    path: 'sales/orders/new',
    name: 'sales-order-new',
    component: () => import('../pages/sales/CreateSalesOrderPage.vue'),
    meta: { requiresModule: 'sales' },
  },
  {
    path: 'sales/orders/:id',
    name: 'sales-order-detail',
    component: () => import('../pages/sales/SalesOrderDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'sales' },
  },
  // ---- Packing / shipments -------------------------------------------------------------------------
  {
    path: 'sales/shipments',
    name: 'sales-shipments',
    component: () => import('../pages/sales/ShipmentsPage.vue'),
    meta: { requiresModule: 'sales' },
  },
  // ---- Customer invoices ------------------------------------------------------------------------------
  {
    path: 'sales/invoices/new',
    name: 'sales-invoice-new',
    component: () => import('../pages/sales/CreateCustomerInvoicePage.vue'),
    meta: { requiresModule: 'sales' },
  },
  {
    path: 'sales/invoices/:id',
    name: 'sales-invoice-detail',
    component: () => import('../pages/sales/CustomerInvoiceDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'sales' },
  },
  // ---- Sales reps and commission (ADR-141) --------------------------------------------------------
  {
    path: 'sales/reps',
    name: 'sales-reps',
    component: () => import('../pages/sales/SalesRepsPage.vue'),
    meta: { requiresModule: 'sales' },
  },
];
